<script>
import AsyncValidator from 'async-validator'
import { FormItem } from 'element-ui'

function noop() {};

export default {
  name: 'WarnFormItem',
  extends: FormItem,
  methods: {

    /**
     * @override
     */
    validate(trigger, callback = noop) {
      this.validateDisabled = false
      const rules = this.getFilteredRule(trigger)
      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback()
        return true
      }

      this.validateState = 'validating'

      const descriptor = {}
      if (rules && rules.length > 0) {
        rules.forEach(rule => {
          delete rule.trigger
        })
      }
      descriptor[this.prop] = rules

      const validator = new AsyncValidator(descriptor)
      const model = {}

      model[this.prop] = this.fieldValue

      validator.validate(model, { firstFields: true }, (errors, invalidFields) => {
        // 添加的逻辑
        // 是 WarnError 对象才进入处理
        if (errors && errors[0].type && errors[0].type === 'warn') {
          // 存在 warnType 参数, 并且是 validator
          const errorRule = rules.find(rule => rule.warnType && rule.validator)
          if (this[errorRule.warnType]) {
            // 使用抛出的错误信息
            this[errorRule.warnType](errors[0].message, errorRule.warnOptions)
          } else {
            console.warn('告警类型 warnType 参数不正确, 可以选择 message/notify/alert 其中之一')
          }

          this.validateState = 'success'
          this.validateMessage = ''
          return callback()
        }
        // 添加的逻辑 end

        this.validateState = !errors ? 'success' : 'error'
        this.validateMessage = errors ? errors[0].message : ''

        callback(this.validateMessage, invalidFields)
        this.elForm && this.elForm.$emit('validate', this.prop, !errors, this.validateMessage || null)
      })
    },

    notify(msg, options = {}) {
      this.$notify(Object.assign({
        title: '提示',
        message: msg,
        type: 'warning',
        duration: 5000,
        position: 'top-right'
      }, options))
    },

    message(msg, options = {}) {
      this.$message(Object.assign({
        message: msg,
        type: 'warning',
        duration: 5000,
      }, options))
    },

    alert(msg, options = {}) {
      this.$message(msg, Object.assign({
        title: '提示',
        type: 'warning',
        duration: 5000,
      }, options))
    }
  }
}
</script>

<style lang="scss">
.el-form-item {
  &.is-warning {
    color: #E6A23C;
  }
}
</style>
